import { useEffect, useRef, useState } from 'react'

import { useInView, useAnimate } from 'framer-motion'
import { useRecoilState } from 'recoil'

import { currentItemIdState } from 'src/atoms/ui.atom'
import { HIGHLIGHT_ANIMATION_DURATION_MS } from 'src/lib/constants'

export default function useCardWrapper(itemId: number) {
  const [scope, animate] = useAnimate()
  const timeout = useRef<NodeJS.Timeout>()
  const [currentItemId, setCurrentItemId] = useRecoilState(currentItemIdState)
  const [shouldHighlight, setShouldHighlight] = useState(false)
  const isVisible = useInView(scope)

  useEffect(() => {
    if (currentItemId === itemId && isVisible) {
      setShouldHighlight(true)
      clearTimeout(timeout.current)
      timeout.current = setTimeout(() => {
        setShouldHighlight(false)
        // We need to reset the currentItemId to not highlight it again
        // so that if the user scrolls away and back to the item,
        // it should not get highlighted again
        setCurrentItemId(null)
      }, HIGHLIGHT_ANIMATION_DURATION_MS)
    }
    return () => {
      clearTimeout(timeout.current)
    }
  }, [currentItemId, isVisible, itemId, setCurrentItemId])
  return { isVisible, shouldHighlight, scope, animate }
}
